// extracted by mini-css-extract-plugin
export var alertIcon = "_py-0";